export default {
    /**
     * Set top listens data for givn key.
     *
     * @param {object} state          Vuex state.
     * @param {object}  payload       Payload.
     * @param {string}  payload.key   Data key.
     * @param {object}  payload.value Top listens data.
     */
    setTopListens(state, { key, value }) {
        state.topListens = {
            ...state.topListens,
            [key]: value,
        };
    },

    /**
     * Set top shows data for givn key.
     *
     * @param {object} state          Vuex state.
     * @param {object}  payload       Payload.
     * @param {string}  payload.key   Data key.
     * @param {object}  payload.value Top listens data.
     */
    setTopShows(state, { key, value }) {
        state.topShows = {
            ...state.topShows,
            [key]: value,
        };
    },

    /**
     * Set listens data for givn key.
     *
     * @param {object} state          Vuex state.
     * @param {object}  payload       Payload.
     * @param {string}  payload.key   Data key.
     * @param {object}  payload.value Listens data.
     */
    setListens(state, { key, value }) {
        state.listens = {
            ...state.listens,
            [key]: value,
        };
    },

    /**
     * Set sources data for givn key.
     *
     * @param {object} state          Vuex state.
     * @param {object}  payload       Payload.
     * @param {string}  payload.key   Data key.
     * @param {object}  payload.value Listens data.
     */
    setSources(state, { key, value }) {
        state.sources = {
            ...state.sources,
            [key]: value,
        };
    },

    /**
     * Set platforms data for givn key.
     *
     * @param {object} state          Vuex state.
     * @param {object}  payload       Payload.
     * @param {string}  payload.key   Data key.
     * @param {object}  payload.value Listens data.
     */
    setPlatforms(state, { key, value }) {
        state.platforms = {
            ...state.platforms,
            [key]: value,
        };
    },
};
